import React, { useEffect, useState } from "react";
// I18n
import { useSelector } from "react-redux";
// MUI
import {
  List,
  ListItem,
  Divider,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Grid,
  makeStyles,
  Button,
  CircularProgress,
  Box,
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import "date-fns";
import moment from "moment";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import ConfirmMealTransferDialog from "components/ConfirmMealTransferDialog";
import { useHistory, useLocation } from "react-router-dom";
import {
  SPECIAL_PROJECT,
  SET_EMPTY,
  INCOMPLETE_STATUS,
  APPROVED_STATUS,
  PENDING_STATUS,
  NEW_STATUS,
  EDIT_STATUS,
  EXCEPTION_STATUS,
  DELETED_STATUS,
  AUTO_COMPLETE_STATUS,
  AUTO_APPROVED_STATUS,
  AUTO_ADJUSTED_STATUS,
} from "../../config";
import { PROJECT, dateConfig, timeConfig, MEAL } from "./config";
import { CUSTOMER_SITE, STATUS_DELETED, DELETED } from "config/CONSTANTS";

import SectionHead from "../../components/SectionHead";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

import Employee from "../../components/Employee";

import { login } from "../Punch/constants";
import Logo from "../../assets/history.png";
import { getDurationInHours, properCase } from "utils";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import MealReminderModal from "./components/MealReminderModal";
import { EventEmitter } from "utils/EventEmitter";
import { getHoursFormat } from "utils/punch";
import { saveMissingMealPunch, getTimesheetActHours } from "services";
import { Autocomplete,  createFilterOptions  } from "@material-ui/lab";
import LoaderView from "components/LoaderView";
const useStyles = makeStyles((theme) => ({
  card: { padding: 20, marginTop: 20 },
  totalHours: {
    align: "right",
    color: theme.palette.primary.dark,
  },
  hours: {
    color: "#1B75BC",
    marginLeft: ".2rem",
  },
  logo: {
    height: 24,
    width: 24,
    marginLeft: 10,
  },
  name: {
    // marginLeft: 24,
    // marginTop: 20,
  },
  loginStatus: {
    // marginRight: 24,
    // marginTop: 20,
    cursor: "pointer",
    align: "right",
  },
  weekTotals: {
    display: "flex",
    flexDirection: "row-reverse",
    cursor: "pointer",
    alignItems: "right",
    justifyContent: "space-between",
  },
  clockIn: {
    // fontSize: 14,
    display: "flex",
    flexDirection: "row-reverse",
    textTransform: "uppercase",
    color: "#8DC13F",
    fontWeight: "bolder",
    paddingTop: 5,
  },
  clockOut: {
    // fontSize: 14,
    display: "flex",
    flexDirection: "row-reverse",
    textTransform: "uppercase",
    color: "#58595B",
    fontWeight: "bolder",
    paddingTop: 5,
  },
  time: {
    // fontSize: 10,
    display: "flex",
    flexDirection: "row-reverse",
    textTransform: "uppercase",
    color: "#58595B",
  },
  notFound: {
    // fontSize: 10,
    display: "flex",
    flexDirection: "row-reverse",
    color: "#58595B",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 350,
    "& .Mui-focused": {
      color: "#1B75BC",
    },
    "& .MuiInput-underline.Mui-focused:after": {
      borderBottomColor: "#1B75BC",
    },
    "& .Mui-error": {
      color: "#f44336",
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: "#f44336",
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  alignButton: {
    // marginRight: 24,
  },
  buttonContainer: {
    marginTop: 20,
    marginBottom: 10,
  },
  pageTitle: {
    marginTop: 20,
    marginLeft: 24,
  },
  lblIn: {
    // fontSize: 16,
    backgroundColor: `${login.clockInColor}1A`,
    color: `${login.clockInColor}`,
    padding: 3,
    borderRadius: 4,
    marginRight: 10,
  },
  lblOut: {
    // fontSize: 16,
    backgroundColor: `${login.outColor}1A`,
    color: `${login.outColor}`,
    padding: 3,
    borderRadius: 4,
    marginLeft: 20,
    marginRight: 10,
  },
  listTop: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
  },
  listlbl: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginRight: 10,
  },
  green: {
    color: `${login.clockInColor}`,
  },
  clockDiv: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  logoDiv: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  txtlbl: {
    fontSize: 15,
  },
}));

export const PunchView = (props) => {
  //Meal data received from Meal Modal

  const history = useHistory();

  // const [mealReminder, setMealReminder] = useState(false);

  const [confirmMealTransferDialog, setconfirmMealTransferDialog] = useState({
    isOpen: false,
    title: "other.btnMealEnd",
    subTitle: "other.btnMealTransferConfirmationMsg",
    alert: "Alert",
  });

  const classes = useStyles();
  const {
    back,
    lastPunch,
    user,
    t,
    district,
    districtOptions,
    districtChange,
    building,
    buildingOptions,
    buildingChange,
    jobFamiliesOptions,
    jobFamily,
    jobFamilyChange,
    activityGroupOptions,
    activityGroup,
    activityGroupChange,
    clockIn,
    clockOut,
    transfer,
    mealStart,
    missedClockIn,
    missedClockOut,
    isVisibleMissedClockIn,
    isVisibleMissedClockOut,
    isVisibleTransfer,
    isVisibleClockIn,
    isDisabledClockOut,
    isDisabledClockIn,
    isDisableException,
    isDisableExceptionLoader,
    setDisableExceptionLoader,
    lastPunchStatus,
    lastPunchTime,
    lastPunchClock,
    modalExceptionTimeStamp,
    closeModalExceptionTimeStamp,
    saveExceptionTimeStamp,
    exceptionDate,
    exceptionTime,
    handleExceptionDateChange,
    handleExceptionTimeChange,
    confirmationMsg,
    closeModalConfirmationMsg,
    confirmationMsgText,
    allowNavigation,
    confirmationTitleText,
    specialProject,
    handleChangeSpecialProject,
    specialProjectDialog,
    cancelSpecialProjectDialog,
    okSpecialProjectDialog,
    isDisabledSpecialProjectOK,
    jobProjectInfoLabel,
    isDisabledTransfer,
    jobProjectInfoVisible,
    errProjectInfoEntry,
    customerSite,
    errCustomerSite,
    customerSiteVisible,
    handleChangeCustomerSite,
    helperTextForFutureTime,
    disableForTime,
    historyHandler,
    dialogOpen,
    handleDialogOpen,
    handleDialogClose,
    punchHistoryDetails,
    project,
    projectOptions,
    projectGroupHandler,
    mealStartProgress,
    validateMissedClockout,
    validateClockOut,
    mealReminder,
    setMealReminder,
    missedClockOutMeal,
    dataLoaded,
    //setExceptionDate
    weekHoursDiagolueOpen,
    weekHoursDetails,
    weekHoursHandler,
    handleWeekHoursClose,
    weekHoursDataLoaded,
    projectInfoVisible,
    projectInfoLabel,
    handleChangeProjectDetails,
    otherProjectInfoVisible,
    handleOtherProjectDetails,
    otherProject,
    otherProjectErr,
    setDisableClockOut
  } = props;

  const defaultDistrict = [
    {
      value: -1,
      label: t("general.select1"),
      buildings: [{ value: -1, label: t("general.select2") }],
    },
  ];
  const defaultJobFamily = [{ label: t("general.select3"), value: -1 }];
  const defaultAG = [{ label: t("general.select4"), value: -1 }];
  const defaultProjectObj = [
    { label: t("other.lblSelectProjectName"), value: " " },
  ];
  // defaultDistrict[0].value - district
  // defaultDistrict[0].buildings[0].value - building
  // defaultJobFamily[0].value - jobFamily
  // defaultAG[0].value - activityGroup
  // defaultActivity[0].value - project

  let JFOptions = [];

  const [mealData, setMealData] = useState("");
  const [activityTotals, setActivityTotals] = useState(0);

  React.useEffect(() => {
    EventEmitter.subscribe("event", (data) => {
      console.log("meal data inside emitter", data);

      console.log("last punch", lastPunch);
      setMealData(data);
    });

    let totals = 0;
    getTimesheetActHours(user.workerId)
      .then((data) => {
        totals = data;
        setActivityTotals(totals);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  React.useEffect(() => {
    console.log("meal and last punch data");
    if (lastPunch && mealData)
      saveMissingMealPunch(mealData, lastPunch)
        .then((data) => {
          console.log("data received after meal", data);
          EventEmitter.dispatch("closePreviousMealModals", true);
          EventEmitter.dispatch("openConfirmMessage", true);
        })
        .catch((err) => {
          console.log("error changing lastPunch status!", err);
          EventEmitter.dispatch("openErrorMessage", err.message);
        });
  }, [mealData]);

  const minDateHandler = (lastPunchClock) => {
    //console.log("hereeee");
    let currStartDate = new Date(
      moment(new Date()).subtract(2, "weeks").startOf("weeks")
    );
    let TS;
    if (lastPunchClock) {
      let startDate = moment(currStartDate).format(dateConfig.format6);
      let minhDate = moment(lastPunchClock).format(dateConfig.format6);

      if (startDate > minhDate) {
        console.log(
          "CURR DATE:1" + startDate + " START DATE" + minhDate + "DIFFF"
        );
        TS = currStartDate;
      } else {
        console.log(
          "CURR DATE:2" + startDate + " START DATE" + minhDate + "DIFFF"
        );
        TS = minhDate;
      }
    } else {
      TS = currStartDate;
    }
    console.log("CURR DATE:" + TS);
    return TS;
  };
  let newMin = minDateHandler(lastPunchClock);
  const filter = createFilterOptions();
  const validateClockOutPunchMeal = () => {
    if (user && user.hasMeal) {
      clockOut();
    } else if (user && !user.hasMeal && !isVisibleClockIn) {
      validateClockOut();
    }
  };

  const getProjectValue = (values, role) => {
    if (!role) return "";
    let value = role;
    for (let val of values) {
      if (val.value == role) {
        value = val;
      }
    }
    return value;
  };

  const validateMissedClockOutPunchMeal = () => {
    if (
      (user && user.hasMeal && isVisibleMissedClockOut) ||
      isVisibleMissedClockIn
    ) {
      saveExceptionTimeStamp();
    } else if (user && !user.hasMeal && isVisibleMissedClockOut) {
      validateMissedClockout();
    }
  };

  const showMealTransferDialog = (e) => {
    setconfirmMealTransferDialog({
      ...confirmMealTransferDialog,
      isOpen: true,
      onConfirm: () => {
        setconfirmMealTransferDialog({
          ...confirmMealTransferDialog,
          isOpen: false,
        });
        history.goBack();
      },
    });
  };

  const WeekHoursTable = (
    <Dialog
      open={weekHoursDiagolueOpen}
      onClose={handleWeekHoursClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      disableBackdropClick
    >
      <DialogTitle id="form-dialog-title" style={{ color: "#1B75BC" }}>
        {t("other.txtActivityHourTotals")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
          <TableContainer>
            <Table style={{ minWidth: 350 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("other.txtDay")}</TableCell>
                  <TableCell align="left">
                    {t("pgHome.lblDuration")} ({t("other.txtHours")})
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {weekHoursDetails.map((row) => (
                  <TableRow key={row.day}>
                    <TableCell component="th" scope="row">
                      {row.day}
                    </TableCell>
                    <TableCell align="left">{row.hours}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleWeekHoursClose} color="primary">
          {t("pgPunch.btnCancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
  const StatusMarkup = ({ activity }) => {
    if (!activity.outLocalTS) activity.status = INCOMPLETE_STATUS;
    let hours = 0;
    if (
      activity.inLocalTS &&
      activity.inLocalTS !== "" &&
      activity.outLocalTS &&
      activity.outLocalTS !== ""
    ) {
      const end = moment(
        activity.outLocalTS && activity.outLocalTS.substr(0, 16)
      );
      const start = moment(
        activity.inLocalTS && activity.inLocalTS.substr(0, 16)
      );
      const diff = moment.duration(end.diff(start));
      hours = diff.asHours();
    }
    hours = hours.toFixed(2);
    if (hours > 24 && activity.status !== DELETED_STATUS)
      activity.status = EXCEPTION_STATUS;

    if (activity.activityGroup === MEAL) activity.jobName = MEAL;

    let color = "";
    let lbl = "";
    switch (activity.status) {
      case DELETED_STATUS:
        color = login.outColor;
        lbl = t("other.lblDeleted");
        break;
      case NEW_STATUS:
        color = login.nameColor;
        lbl = t("other.lblPending");
        break;
      case EDIT_STATUS:
        color = login.nameColor;
        lbl = t("other.lblPending");
        break;
      case APPROVED_STATUS:
        color = login.clockInColor;
        lbl = t("other.lblApproved");
        break;
      case INCOMPLETE_STATUS:
        color = login.outColor;
        lbl = t("other.lblIncomplete");
        break;
      case EXCEPTION_STATUS:
        color = login.clockOutColor;
        lbl = t("other.lblException");
        break;
      case AUTO_APPROVED_STATUS:
        color = login.clockInColor;
        lbl = t("other.lblAutoApproved");
        break;
      case AUTO_COMPLETE_STATUS:
        color = login.clockOutColor;
        lbl = t("other.lblAutoComplete");
        break;
      case AUTO_ADJUSTED_STATUS:
        color = login.clockOutColor;
        lbl = t("other.lblAutoAdjusted");
        break;
      default:
        break;
    }

    return (
      <>
        <div className={classes.listlbl}>{activity.jobName}</div>
        <div className={[classes.listlbl]}>
          <Typography style={{ fontSize: 15, color: color }}>
            {lbl && lbl.toUpperCase()}
          </Typography>
        </div>
      </>
    );
  };
  return (
    <>
      <Grid container direction="row" justify="center">
        <Grid item sm={7} xs={12}>
          <Paper elevation={3} className={classes.card}>
            {lastPunch &&
            lastPunch.activityGroup === MEAL &&
            !lastPunch.outLocalTS &&
            !lastPunch.outTS &&
            lastPunch.status != DELETED ? (
              <SectionHead
                back={showMealTransferDialog}
                name={properCase(t("pgPunch.title"))}
              />
            ) : (
              <SectionHead back={back} name={properCase(t("pgPunch.title"))} />
            )}
            <Grid container direction="row">
              <Grid item xs={9}>
                <Employee user={user} />
              </Grid>
              <Grid item xs={3}>
                {!lastPunch || (lastPunch && !lastPunch.activityName) ? null : (
                  // <section
                  //  // onClick={historyHandler}
                  //   className={classes.loginStatus}
                  // >
                  <div className={classes.clockDiv}>
                    {lastPunch && lastPunch.status === STATUS_DELETED ? (
                      <div>
                        <Typography variant="h6" className={classes.notFound}>
                          Status Unavailable
                        </Typography>
                        <section
                          onClick={weekHoursHandler}
                          className={classes.weekTotals}
                        >
                          <div
                            style={{
                              display: "flex",
                              // flex: 1,
                              flexDirection: "row",
                              alignItems: "right",
                              // justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              className={classes.totalHours}
                            >
                              {properCase(t("other.lblWeekTotal"))}:
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              className={classes.hours}
                            >
                              {getHoursFormat(activityTotals)} Hrs
                            </Typography>
                          </div>
                        </section>
                      </div>
                    ) : (
                      <div>
                        {isVisibleMissedClockOut && (
                          <Typography variant="h6" className={classes.clockIn}>
                            {lastPunchStatus}
                          </Typography>
                        )}
                        {isVisibleMissedClockIn && (
                          <Typography variant="h6" className={classes.clockOut}>
                            {lastPunchStatus}
                          </Typography>
                        )}

                        <Typography
                          className={classes.time}
                          variant="subtitle2"
                        >
                          {lastPunchTime}
                        </Typography>
                        <section
                          onClick={weekHoursHandler}
                          className={classes.weekTotals}
                        >
                          <div
                            style={{
                              display: "flex",
                              // flex: 1,
                              flexDirection: "row",
                              alignItems: "right",
                              // justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              className={classes.totalHours}
                            >
                              {properCase(t("other.lblWeekTotal"))}:
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              className={classes.hours}
                            >
                              {getHoursFormat(activityTotals)} Hrs
                            </Typography>
                          </div>
                        </section>
                      </div>
                    )}
                    <div className={classes.logoDiv}>
                      <section
                        onClick={historyHandler}
                        className={classes.loginStatus}
                      >
                        <img src={Logo} className={classes.logo} />
                      </section>
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
            {/* <Grid>{WeekHoursTable}</Grid> */}
            {weekHoursDataLoaded ? WeekHoursTable : null}

            <Grid container direction="row" justify="center">
              <Grid item xs={12} sm={12}>
                <FormControl
                  error={district === defaultDistrict[0].value}
                  required
                  className={classes.formControl}
                >
                  <InputLabel id="district-label">
                    {t("pgPunch.lblDistrict")}
                  </InputLabel>
                  <Select
                    labelId="district-label"
                    id="district-select"
                    value={district}
                    onChange={districtChange}
                  >
                    {districtOptions &&
                      districtOptions.map((item, idx) => (
                        <MenuItem key={idx} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl
                  error={building === defaultDistrict[0].buildings[0].value}
                  required
                  className={classes.formControl}
                >
                  <InputLabel id="building-label">
                    {" "}
                    {t("pgPunch.lblBuilding")}
                  </InputLabel>
                  <Select
                    labelId="building-label"
                    id="building-select"
                    value={building}
                    onChange={buildingChange}
                  >
                    {(user && user.isApprover
                      ? buildingOptions
                      : buildingOptions.filter((item) => !item.mgrOnly)
                    ).map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {customerSiteVisible && building == CUSTOMER_SITE && (
                <Grid item xs={12} sm={12}>
                  <FormControl
                    error={customerSite === ""}
                    required
                    className={classes.formControl}
                  >
                    <TextField
                      // multiline
                      autoFocus
                      id="cs"
                      // label={t("pgPunch.phCustomerSite")}
                      type="text"
                      fullWidth
                      value={customerSite}
                      onChange={handleChangeCustomerSite}
                      placeholder={t("pgPunch.subTextCustomerSite")}
                      error={errCustomerSite}
                      inputProps={{ maxLength: 100 }}
                    />
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12} sm={12}>
                <FormControl
                  error={jobFamily === defaultJobFamily[0].value}
                  required
                  className={classes.formControl}
                >
                  <InputLabel id="job-familiy-label">
                    {t("pgPunch.lblJobFamily")}
                  </InputLabel>
                  <Select
                    labelId="job-familiy-label"
                    id="job-familiy-select"
                    value={jobFamily}
                    onChange={jobFamilyChange}
                  >
                    {
                      ((JFOptions =
                        user && user.isApprover
                          ? jobFamiliesOptions
                          : jobFamiliesOptions.filter((item) => !item.mgrOnly)),
                      JFOptions.map((item, idx) => (
                        <MenuItem key={idx} value={item.value}>
                          {item.label}
                        </MenuItem>
                      )))
                    }
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormControl
                  error={activityGroup === defaultAG[0].value}
                  required
                  className={classes.formControl}
                >
                  <InputLabel id="activity-group-label">
                    {t("pgPunch.lblActivityGroup")}
                  </InputLabel>
                  <Select
                    labelId="activity-group-label"
                    id="activity-group-select"
                    value={activityGroup}
                    onChange={activityGroupChange}
                  >
                    {/* added filter for removing leave as activity group from worker journey */}
                    {activityGroupOptions
                      .filter((item) => !item.mgrOnly)
                      .map((item, idx) => (
                        <MenuItem key={idx} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              {projectOptions.length > 1 ? (
                <Grid item xs={12} sm={12}>
                  <FormControl className={classes.formControl}>
                    <Autocomplete
                      options={projectOptions}
                      getOptionLabel={(option) => option.label}
                      groupBy={(option)=> option.parent}
                     
                     fullWidth
                      onChange={(e, v) =>{
                        projectGroupHandler({
                          target: {
                            value: v ? v.value : "",
                          },
                        })
                      }
                      }
                      clearOnBlur
                      selectOnFocus
                      handleHomeEndKeys
                      filterSelectedOptions
                      value={{
                        label: getProjectValue(projectOptions, project).label,
                      }}
                      // filterOptions={(options, params) => {
                      //   const filtered = filter(options, params);
                      //    const { inputValue } = params;
                      //    const isExisting = options.some((option) => inputValue === option.label);
                      //    if(inputValue !='' && !isExisting && activityGroup === PROJECT){
                      //     filtered.push({
                      //       value:inputValue,
                      //       label: inputValue,
                      //     });
                      //    }
                      //   return filtered;
                      // }}

                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label={
                            activityGroup === PROJECT
                              ? t("other.phJobProjectInfo")+' *'
                              : t("other.lblSelectActivityName")
                          }
                          id="activity-name-select"
                          name="activity-name-select"
                          // error={errorMessage.project ? true : false}
                          // helperText={errorMessage.project}
                          error={activityGroup === PROJECT &&
                            (project === defaultProjectObj[0].value) ||
                            (project ===SET_EMPTY)
                            }
                        />
                      )}
                      // value={project}
                     
                    />

                    {/* <Select
                      labelId="activity-name-label"
                      id="activity-name-select"
                      value={project}
                      onChange={projectGroupHandler}
                    >
                      {projectOptions.map((item, idx) => (
                        <MenuItem key={idx} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select> */}
                  </FormControl>
                </Grid>
              ) : (
                activityGroup !== -1 &&
                jobProjectInfoVisible && (
                  <Grid item xs={12} sm={12}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        autoFocus
                        id="sp"
                        // label={
                        //   activityGroup === PROJECT
                        //     ? t("other.phJobProjectInfo")
                        //     : t("other.lblActivityName")
                        // }
                        type="text"
                        fullWidth
                        value={jobProjectInfoLabel}
                        onChange={handleChangeSpecialProject}
                        placeholder={
                          activityGroup === PROJECT
                            ? t("other.phJobProjectInfo")
                            : t("other.lblActivityName")
                        }
                        inputProps={{ maxLength: 100 }}
                        error={activityGroup === PROJECT ?
                          (jobProjectInfoLabel === defaultProjectObj[0].value) ||
                          (jobProjectInfoLabel ===SET_EMPTY):false
                          }
                      />
                    </FormControl>
                  </Grid>
                )
              )}

              {otherProjectInfoVisible && (
                  <Grid item xs={12} sm={12}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        autoFocus
                        id="proj"
                        type="text"
                        fullWidth
                        value={otherProject}
                        onChange={handleOtherProjectDetails}
                        placeholder= {t("other.lblOtherProjectDetails")}
                        inputProps={{ maxLength: 100 }}
                        error={activityGroup === PROJECT ?
                          (otherProject ===SET_EMPTY || otherProjectErr):false
                          }
                          helperText={otherProjectErr}
                      />
                    </FormControl>
                  </Grid>
                )
              }


                {projectInfoVisible && (
                  <Grid item xs={12} sm={12}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        autoFocus
                        id="proj"
                        type="text"
                        fullWidth
                        value={projectInfoLabel}
                        onChange={handleChangeProjectDetails}
                        placeholder= 'Project Details'
                        inputProps={{ maxLength: 100 }}
                      />
                    </FormControl>
                  </Grid>
                )
                      }
            </Grid>

            <Grid
              container
              direction="row"
              justify="flex-end"
              //spacing={0}
              className={classes.buttonContainer}
            >
              <Grid item>
                {isVisibleMissedClockIn && (
                  <Button
                    variant="text"
                    color="primary"
                    onClick={missedClockIn}
                    disabled={isDisabledClockIn} // disable exception button if clock out is disabled ... transfer is enabled
                  >
                    {t("pgPunch.btnMissedClockedIn")}
                  </Button>
                )}
              </Grid>
              <Grid item>
                {isVisibleMissedClockOut && (
                  <Button
                    variant="text"
                    color="primary"
                    onClick={missedClockOut}
                    disabled={isDisabledClockOut || mealStartProgress} // disable exception button if clock out is disabled ... transfer is enabled and when clicked on mealstart
                  >
                    {t("pgPunch.btnMissedClockedOut")}
                  </Button>
                )}
              </Grid>
            </Grid>

            <Grid container direction="row" justify="flex-end" spacing={2}>
              <>
                <Grid item xs={6} sm={3}>
                  <Button
                    fullWidth={true}
                    variant="outlined"
                    color="primary"
                    onClick={transfer}
                    disabled={isDisabledTransfer}
                  >
                    {t("pgPunch.btnTransfer")}
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    fullWidth={true}
                    variant="outlined"
                    color="primary"
                    onClick={mealStart}
                    disabled={isDisabledClockOut || mealStartProgress}
                  >
                    {mealStartProgress ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            marginRight: 10,
                          }}
                        >
                          <CircularProgress size={14} />
                        </div>
                        {t("other.btnMealStart")}
                      </div>
                    ) : (
                      t("other.btnMealStart")
                    )}
                  </Button>
                </Grid>
              </>
            </Grid>

            <Grid container direction="row" justify="flex-end" spacing={2}>
              {isVisibleClockIn && (
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={clockIn}
                    disabled={isDisabledClockIn}
                    fullWidth={true}
                  >
                    {t("pgPunch.btnClockIn")}
                  </Button>
                </Grid>
              )}

              {!isVisibleClockIn && (
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={validateClockOutPunchMeal}
                    className={classes.alignButton}
                    disabled={isDisabledClockOut || mealStartProgress}
                    fullWidth={true}
                  >
                    {t("pgPunch.btnClockOut")}
                  </Button>
                </Grid>
              )}
            </Grid>
            {mealReminder && (
              <MealReminderModal
                setMealReminder={setMealReminder}
                mealReminder={mealReminder}
                setDisableExceptionLoader = {setDisableExceptionLoader}
                setDisableClockOut = {setDisableClockOut}
                //isDisableExceptionLoader = {isDisableExceptionLoader}
                // clockOut={isVisibleMissedClockOut?saveExceptionTimeStamp:clockOut}
                clockOut={
                  isVisibleMissedClockOut && modalExceptionTimeStamp
                    ? saveExceptionTimeStamp
                    : clockOut
                }
                exceptionDate={exceptionDate}
                exceptionTime={exceptionTime}
                callingFromMissedClockOut={
                  modalExceptionTimeStamp ? true : false
                }
              />
            )}
          </Paper>
        </Grid>
      </Grid>

      <Dialog
        open={modalExceptionTimeStamp}
        onClose={closeModalExceptionTimeStamp}
        aria-labelledby="Punch-date-time-dialog"
        disableBackdropClick
      >
        <LoaderView loading={isDisableExceptionLoader}>
        <DialogTitle id="form-dialog-title">
          {t("pgPunch.txtPunchDateTimeDialogTitle")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("pgPunch.txtProvideDateTime")}
          </DialogContentText>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="space-around" spacing={2}>
              <Grid item>
                <KeyboardDatePicker
                  inputVariant="outlined"
                  disableBackdropClick
                  margin="normal"
                  id="date-picker-dialog"
                  label={t("pgPunch.lblSelectPunchDate")}
                  format="dd/MM/yyyy"
                  value={exceptionDate}
                  onChange={handleExceptionDateChange}
                  minDate={newMin}
                  maxDate={new Date()}
                  KeyboardButtonProps={{
                    "aria-label": "Select Punch Date",
                  }}
                />
              </Grid>

              <Grid item>
                <Grid container direction="column">
                  <KeyboardTimePicker
                    inputVariant="outlined"
                    ampm={false}
                    disableBackdropClick
                    margin="normal"
                    id="time-picker"
                    error={disableForTime}
                    label={t("pgPunch.lblSelectPunchTime")}
                    value={exceptionTime}
                    onChange={handleExceptionTimeChange}
                    KeyboardButtonProps={{
                      "aria-label": "Select Punch Time",
                    }}
                    keyboardIcon={<AccessTimeIcon />}
                  />
                  <FormHelperText error>
                    {helperTextForFutureTime}
                  </FormHelperText>
                </Grid>
              </Grid>
            </Grid>
          </MuiPickersUtilsProvider>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeModalExceptionTimeStamp}
            color="primary"
            variant="outlined"
          >
            {t("general.cancelBtn")}
          </Button>
          <Button
            onClick={validateMissedClockOutPunchMeal}
            color="primary"
            variant="contained"
            disabled={isDisableException}
          >
            {t("general.saveBtn")}
          </Button>
        </DialogActions>
        </LoaderView>
      </Dialog>

      <Dialog
        open={confirmationMsg}
        onClose={closeModalConfirmationMsg}
        aria-labelledby="confirmation-dialog"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title">
          {confirmationTitleText}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{confirmationMsgText}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeModalConfirmationMsg} color="primary">
            {t("pgPunch.btnOK")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={specialProjectDialog}
        aria-labelledby="special-project-dialog"
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="form-dialog-title">{jobProjectInfoLabel}</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            autoFocus
            id="sp"
            label="Details"
            type="text"
            fullWidth
            value={specialProject}
            onChange={handleChangeSpecialProject}
            placeholder="Enter Characters"
            helperText="Enter 0 if not applicable"
            inputProps={{ maxLength: 100 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelSpecialProjectDialog} color="primary">
            {t("general.cancelBtn")}
          </Button>
          <Button
            onClick={okSpecialProjectDialog}
            color="primary"
            disabled={isDisabledSpecialProjectOK}
          >
            {t("general.saveBtn")}
          </Button>
        </DialogActions>
      </Dialog>

      <ConfirmMealTransferDialog
        ConfirmMealTransferDialog={confirmMealTransferDialog}
        setconfirmMealTransferDialog={setconfirmMealTransferDialog}
        lastPunch={lastPunch}
      />
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        disableBackdropClick
      >
        <DialogTitle id="form-dialog-title" style={{ color: "#1B75BC" }}>
          {properCase(t("other.titleActivityHistory"))}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            {punchHistoryDetails != null &&
              punchHistoryDetails.map((listitem) => {
                {
                  console.log("list item", listitem);
                }
                return (
                  <List>
                    <>
                      <ListItem>
                        <ListItemText
                          key={listitem.id}
                          primary={
                            <div className={classes.listTop}>
                              {listitem.status ? (
                                <StatusMarkup activity={listitem} />
                              ) : null}
                            </div>
                          }
                          primaryTypographyProps={{ color: "textPrimary" }}
                          secondary={
                            <div className={classes.listTop}>
                              <div className={classes.listlbl}>
                                <p className={classes.lblIn}>
                                  {t("other.inLbl")}
                                </p>
                                <p>
                                  {moment(listitem.inLocalTS).format(
                                    dateConfig.format2
                                  ) +
                                    " " +
                                    moment(listitem.inLocalTS).format(
                                      timeConfig.format3
                                    )}
                                </p>
                              </div>
                              <div className={classes.listlbl}>
                                {isNaN(listitem.outLocalTS) ? (
                                  <p className={classes.lblOut}>
                                    {t("other.outLbl")}
                                  </p>
                                ) : null}

                                {!isNaN(listitem.outLocalTS) ? null : (
                                  <>
                                    <p>
                                      {" "}
                                      {moment(listitem.outLocalTS).format(
                                        dateConfig.format2
                                      ) +
                                        " " +
                                        moment(listitem.outLocalTS).format(
                                          timeConfig.format3
                                        )}
                                    </p>
                                  </>
                                )}
                              </div>
                            </div>
                          }
                        />
                      </ListItem>
                      <Divider variant="fullWidth" component="li" />
                    </>
                  </List>
                );
              })}
          </DialogContentText>
          {Object.keys(punchHistoryDetails).length === 0 && dataLoaded && (
            <DialogContentText>{t("other.txtNoRecord")}</DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            {t("pgPunch.btnCancel")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

PunchView.propTypes = {};

export default PunchView;
